import React from "react";
import { PracticeConnectionsCardHeader } from "../practice-connections-card-header";
import { PracticeConnectionTable } from "../practice-connections-table";
import useConnections from "../../../Connections/hooks/useConnections";
import { Button } from "../../../../ui/button";

const PracticesByClientSelectedDiva = ({ closeModal }) => {
  const {
    allPractices: clients,
    canUseMultiPractice,
    localSelectedPractices,
    handleClickLocalPractice,
    handleUnCheckAllLocalPractices,
    handleCheckAllLocalPractices,
    practiceFilter,
    setPracticeFilter,
    filteredLocalSelectedPractices,
    handleClickSetPractices,
  } = useConnections();

  const practicesConnected = localSelectedPractices.filter(
    (practice) => practice.isConnected,
  );

  return (
    <React.Fragment>
      <div className="bg-white rounded-xl  border-gray-200">
        <PracticeConnectionsCardHeader
          handleCheckAllLocalPractices={handleCheckAllLocalPractices}
          practicesConnected={practicesConnected}
          handleUnCheckAllLocalPractices={handleUnCheckAllLocalPractices}
          localSelectedPractices={localSelectedPractices}
          practiceFilter={practiceFilter}
          setPracticeFilter={setPracticeFilter}
          canUseMultiPractice={canUseMultiPractice}
        />
        <PracticeConnectionTable
          localSelectedPractices={filteredLocalSelectedPractices}
          handleClickLocalPractice={handleClickLocalPractice}
        />
      </div>

      <div className="flex mt-4 items-center justify-center">
        <Button
          className="bg-[#136C62]!bg-teal-600 hover:bg-teal-800 text-white !rounded-lg !h-9 gap-2 mr-3"
          onClick={handleClickSetPractices}
        >
          Active selected practices
        </Button>
        <Button
          variant="secondary"
          className="text-white !rounded-lg !h-9 gap-2"
          onClick={() => closeModal()}
        >
          Cancel
        </Button>
      </div>
    </React.Fragment>
  );
};

export default PracticesByClientSelectedDiva;
